// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * The datagram event types a row applies to. Bit n is wire value n.
 */
export enum EventTypes {
  Log = 1,
  GeneralFault = 2,
  CarOperation = 4,
  HallCallsDisabled = 8,
}
